import { useState, } from 'react';
import Box from '@material-ui/core/Box';
import { makeStyles } from "@material-ui/core/styles";
import Draggable from 'react-draggable';

const useStyles = makeStyles(() => ({
    root: {
        borderRadius: 5,
        position: 'absolute',
        bottom: 20,
        left: 20,
        zIndex: 2,
        boxShadow: '0 0 1em rgb(0 0 0 / 20%)',
    },

    legend: {
        backgroundColor: 'lightgray',
        borderRadius: 5,
        font: "20px/28px 'Hiragino Kaku Gothic ProN', 'YuGothic', 'Meiryo', 'sans-serif'",
        padding: '1em',
        color: '#222',
    },

    unit: {
        margin: '0 0 10px',
    },

    mark: {
        display: 'inline-block',
        height: 25,
        marginRight: 5,
        marginBottom: 5,
        width: 25,
        verticalAlign: 'middle',
    },

    value: {
        display: 'inline-block',
        height: 25,
        verticalAlign: 'middle',
    }
}));

export function LegendsDialog(props) {
    const { legends } = props;
    const classes = useStyles();
    const [position, setPosition] = useState({ x: 0, y: 0 });

    const onDrop = (e, position) => {
        setPosition({ x: position.x, y: position.y });
    };

    let legendBoxes = [];
    legends.forEach(legend => {
        legendBoxes.push(
            <Box key={legend.id} className={classes.legend} mb={2}>
                <h4 className={classes.unit}>{legend.unit}</h4>
                {legend.items.slice().reverse().map((item, i) => {
                    return (
                        <Box key={i}>
                            {item.color
                                ? <Box className={classes.mark} style={{ backgroundColor: item.color }}></Box>
                                : <Box className={classes.mark} style={{ backgroundImage: `url(${item.image})` }}></Box>}
                            <Box className={classes.value}>{item.value}</Box>
                        </Box>
                    );
                })}
            </Box>
        );
    });

    return (
        <Draggable position={position} onStop={onDrop}>
            <Box className={classes.root}>{legendBoxes}</Box>
        </Draggable>
    );
};

export default LegendsDialog;